module.exports = __webpack_public_path__ + "media/images/icon/check-cad73dd8e9f6faaccf852bb5443c7fa8.png";